import React from 'react'
import styled from 'styled-components'
import { useTranslate } from '@tolgee/react';
import { ReactComponent as SadFace } from "../../Assets/iconsv2/generic/sadFace.svg"
const EmptyMeetingList = ({ messageKey = 'meetings.meeting_empty_list' }) => {
    const { t } = useTranslate();
    return (

        <EmptyCallListWrapper>
            <SadFace />
            <p>{t(messageKey)}</p>
        </EmptyCallListWrapper>

    )
}

export default EmptyMeetingList

const EmptyCallListWrapper = styled.div`
display:flex;
flex-direction:column;
gap:8px;
align-items:center;
justify-content:center;
margin:auto;
color:${({ theme }) => theme.menu.secondaryTextColor};
`